import { DrawerLayoutComponent } from '@ContractBuilder/modules/drawer-layout';
import type { CommentAnchor } from '@domain/schemas/comment.schema';
import { create } from 'zustand';

import { useDrawerStore } from './drawer.store';

export interface PendingThread {
  blockId: string;
  anchor?: CommentAnchor;
}

interface CommentsUIStore {
  activeBlockId: string | undefined;
  /** Threads expanded in the panel; only the first one shows the reply composer. */
  activeThreadIds: string[];
  pendingThread: PendingThread | undefined;
  setActiveBlockId: (id: string | undefined) => void;
  setActiveThreadIds: (ids: string[]) => void;
  openThreads: (blockId: string, threadIds: string[]) => void;
  startThread: (blockId: string, anchor?: CommentAnchor) => void;
  clearPendingThread: () => void;
  reset: () => void;
}

export const useCommentsUIStore = create<CommentsUIStore>((set, get) => ({
  activeBlockId: undefined,
  activeThreadIds: [],
  pendingThread: undefined,
  setActiveBlockId: (id: string | undefined) => {
    set({ activeBlockId: id });

    if (!useDrawerStore.getState().isOpen) {
      useDrawerStore.getState().openDrawer({
        type: DrawerLayoutComponent.Comments,
        props: { blockId: id },
      });
    }
  },
  setActiveThreadIds: (ids) => set({ activeThreadIds: ids }),
  openThreads: (blockId, threadIds) => {
    set({ activeThreadIds: threadIds, pendingThread: undefined });
    get().setActiveBlockId(blockId);
  },
  startThread: (blockId, anchor) => {
    set({ pendingThread: { blockId, anchor }, activeThreadIds: [] });
    get().setActiveBlockId(blockId);
  },
  clearPendingThread: () => set({ pendingThread: undefined }),
  reset: () => set({ activeBlockId: undefined, activeThreadIds: [], pendingThread: undefined }),
}));
